import React from "react";
import { useTranslation } from "react-i18next";
import TournamentSubtabsContent from "src/pages/poker/tournaments/TournamentSubtabsContent";

/**
 * TBCB-specific wrapper for TournamentSubtabsContent that handles common translations
 * 
 * @param {Object} props
 * @param {Object} props.tournamentContent - The tournament content from translations
 * @returns {JSX.Element}
 */
const TBCBTournamentSubtabsContent = ({ tournamentContent }) => {
  const { t } = useTranslation();
  
  // Clone the content to avoid mutating the original
  const enhancedContent = { ...tournamentContent };
  
  if (enhancedContent?.content) {
    enhancedContent.content = { ...enhancedContent.content };
    
    // Handle subTab3 (Game Description) - compose common intro + specific prizes
    if (enhancedContent.content.prizeList) {
      const commonIntro = t("tbcbCommon.gameDescription.intro");
      enhancedContent.content.text = `${commonIntro}\n\n${enhancedContent.content.prizeList}`;
    }
    
    // Handle subTab4 (General Rules) - use common text if marked
    if (enhancedContent.content.useCommon) {
      enhancedContent.content.text = t("tbcbCommon.generalRules.text");
    }
  }
  
  return <TournamentSubtabsContent tournamentContent={enhancedContent} />;
};

export default TBCBTournamentSubtabsContent;
